<template>
  <Form @submit="onSubmit" :validation-schema="schema">
    <div v-for="option in options" :key="option">
      <div class="py-2">
        <label class="cursor-pointer">
          <div class="p-3 border border-gray-200 rounded-md" :class="{ ' border-slate-600': option == tempSelection }">
            <div class="flex items-center justify-between">
              <div for="selectedOption" class="block text-sm font-medium text-gray-700 dark:text-white">
                {{ option }}
              </div>
              <Field @change="onChange($event)" name="selectedOption" type="radio" :value="option" class="w-5 h-5 border-gray-300 text-slate-600 focus:ring-slate-500" />
            </div>
          </div>
        </label>
      </div>
    </div>
    <error-message class="mt-1 text-sm text-red-500" name="selectedOption"></error-message>

    <TaskSubmitButton :cta="'Submit'" :correct="answer.correct" @skip="$emit('skip', $event)" />
  </Form>
</template>

<script>
import { Form, Field, ErrorMessage } from "vee-validate";
import TaskSubmitButton from "../task/TaskSubmitButton.vue";
import { ref } from "vue";
export default {
  components: {
    Form,
    Field,
    ErrorMessage,
    TaskSubmitButton,
  },
  props: {
    options: Array,
    solution: Array,
  },

  setup(props, { emit }) {
    const answer = ref({
      item: null,
      correct: null,
    });
    const schema = ref({
      selectedOption: (value) => {
        if (value) {
          return true;
        }
        return "Please select your answer.";
      },
    });
    const tempSelection = ref("");
    const onChange = (event) => {
      tempSelection.value = event.target.value;
    };
    function onSubmit(e) {
      // evaluate answer
      const correct = props.solution[0].toLowerCase() === e.selectedOption.toLowerCase() ? true : false;

      answer.value = {
        item: e.selectedOption,
        correct: correct,
      };

      emit("answer", answer.value);
    }

    return {
      schema,
      answer,
      onSubmit,
      onChange,
      tempSelection,
    };
  },
};
</script>
